import { render, staticRenderFns } from "./PatientsFormAuth.vue?vue&type=template&id=5925af42&"
import script from "./PatientsFormAuth.vue?vue&type=script&lang=js&"
export * from "./PatientsFormAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports